import type { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { z } from 'zod';
import useUserPlatform from '@/hooks/use-user-platform';
import ROUTES from '@/routes';
import { handleDisplayGroupMessages } from '@/routes/messages/groups/_layout.loader';
import { handleDisplaySessionMessages } from '@/routes/messages/sessions/_layout.loader';

export default function SessionLink(props: PropsWithChildren<SessionLinkProps>) {
  const { children, messageId, onClick } = props;
  const { isDesktop } = useUserPlatform();
  const isGroup = 'groupId' in props;

  const to = ROUTES.MESSAGES[isGroup ? 'GROUPS' : 'SESSIONS'].$buildPath({
    params: { id: isGroup ? props.groupId : props.sessionId },
    searchParams: { search: messageId },
  });

  return (
    <Link
      to={to}
      onClick={(e) => {
        onClick?.();
        if (!isDesktop) return;
        e.preventDefault();
        isGroup
          ? handleDisplayGroupMessages(props.groupId, messageId)
          : handleDisplaySessionMessages(props.sessionId, messageId);
      }}>
      {children}
    </Link>
  );
}

const baseLink = z.object({
  messageId: z.number().optional(),
  onClick: z.function().optional(),
});
const sessionLink = baseLink.extend({
  sessionId: z.number(),
});
const groupLink = baseLink.extend({
  groupId: z.number(),
});

const SessionLinkProps = z.union([sessionLink, groupLink]);
type SessionLinkProps = z.infer<typeof SessionLinkProps>;
